export default __webpack_public_path__ + "static/media/쉐어플러그_02.79660ea5.svg";